<template>
  <div class="hzc-industry-dynamics">
    <div class="back">当前位置：<span @click="back">焦煤</span> > 下游企业</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>下游企业</p>
        <div class="btn fr">搜索</div>
        <input class="fr" type="text" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('issue_coal_company_day')" :class="{'hover':flag === 'issue_coal_company_day'}">焦煤可用天数</div>
        <div @click="changeTabs('issue_coal_company_total')" :class="{'hover':flag === 'issue_coal_company_total'}">焦煤库存</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="goDetail(item.completeOriginalDate, flag)">{{
              item.date + (flag === 'issue_coal_company_day' ? '焦煤可用天数' : '焦煤库存')
            }}</p>
          <span class="fr">{{ item.originalDate }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="homePage">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="lastPage">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  downstreamList,
} from '@/api/coal'

export default {
  data() {
    return {
      list: [],
      page: 1,
      size: 15,
      total: 0,
      flag: 'issue_coal_company_day'
    }
  },
  created() {
    if (this.$route.query && this.$route.query['flag']) {
      this.flag = this.$route.query['flag'];
    }
    this.getList({pageNum: this.page, pageSize: this.size, dictDataType: this.flag, dataType: 2});
  },
  methods: {
    // 列表
    getList(pageParams) {
      downstreamList(pageParams).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.flag = num;
      this.page = 1;
      this.getList({pageNum: this.page, pageSize: this.size, dictDataType: this.flag, dataType: 2});
    },
    /**
     * 前往详情页
     */
    goDetail(id, flag) {
      this.$router.push({path: `/coal/downStream`, query: {id, flag}})
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/coal')
    },
    /**
     * 分页
     */
    changePage(page) {
      this.page = page;
      this.getList({pageNum: this.page, pageSize: this.size, dictDataType: this.flag, dataType: 2});
    },
    /**
     * 首页
     */
    homePage() {
      this.changePage(1)
    },
    /**
     * 末页
     */
    lastPage() {
      let cpage = Math.ceil(this.total / this.size);
      this.changePage(cpage)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
